import {ADVANCE_FILTER_ANALYTICS_ORDER} from "../../utils/input-field-list";
import {CloseIcon, FilterIcon, FilterWhiteIcon} from "../../utils/image";
import React, {useEffect, useState} from "react";
import {setToolsModalVisibility} from "../../reducers/tools.reducer";
import {useDispatch, useSelector} from "react-redux";
import ModalCardComponent from "../../components/modal-card.component";
import {advanceFilterAnalyticsOrderModel,} from "../../models/advance-filter";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setAnalyticsOrderAdvanceFilter} from "../../reducers/analytics-order.reducer";
import InputComponent from "../../components/input.component";

const AdvanceFilter = () => {
    const dispatch = useDispatch()
    const {modalVisibility} = useSelector(state => state.toolsReducer)
    const {advanceFilter} = useSelector(state => state.analyticsOrderReducer)
    const fieldList = ADVANCE_FILTER_ANALYTICS_ORDER
    const {fetching: getShippingMethod} = useFetch(API.SHIPPING_METHOD)
    const {fetching: getPaymentMethod} = useFetch(API.PAYMENT_METHOD, {withoutGrouping: true})
    const [data, setData] = useState(advanceFilterAnalyticsOrderModel)
    const [prevData, setPrevData] = useState(advanceFilterAnalyticsOrderModel)

    useEffect(() => {
        Promise.all([getPaymentMethod(), getShippingMethod()])
            .then(response => {
                fieldList[0][1].dataList = response[0].data
                fieldList[1].dataList = response[1].data
            })
            .catch(err => {
                console.log(err)
            })
    }, [])

    const onChange = (key, dataFilter) => {
        setData({...data, ...{[key]: dataFilter}})
    }

    const showModalHandler = () => {
        dispatch(setToolsModalVisibility({filter: true}))
    }

    const closeModalHandler = () => {
        dispatch(setToolsModalVisibility({filter: false}))
    }

    const filteredCountCheck = () => {
        let count = 0
        Object.keys(advanceFilter).map(item => {
            count += advanceFilter[item]?.length
        })
        return count
    }

    const onSubmitHandler = (buttonType, e) => {
        e.preventDefault()
        if (buttonType === 'submit') {
            setPrevData(data)
            const mapData = {
                ...data,
                voucher_codes: data.voucher_codes.map(val => val.code)
            }
            dispatch(setAnalyticsOrderAdvanceFilter(mapData))
            dispatch(setToolsModalVisibility({filter: false}))
        } else {
            setData(advanceFilterAnalyticsOrderModel)
        }
    }

    useEffect(() => {
        if (advanceFilter.voucher_codes.length > 0) {
            setData({
                ...prevData, ...{
                    voucher_codes: advanceFilter.voucher_codes.map(i => {
                        return {
                            id: i?.id || null, code: i?.code || i
                        }
                    })
                }
            })
        } else {
            setData(prevData)
        }
    }, [modalVisibility.filter])

    return (
        <>
            <div onClick={showModalHandler}
                 className={`row items-center space-x-2 px-3 py-2 font-semibold rounded-lg border border-placebo cursor-pointer ${filteredCountCheck() > 0 && 'bg-battleship-green text-white'} relative`}>
                <img className={"h-5"} src={filteredCountCheck() > 0 ? FilterWhiteIcon : FilterIcon} alt="filter"/>
                <p>Filter</p>
                <div className={`absolute -right-1 -top-3.5 py-1 px-2.5 bg-monstera rounded-full ${filteredCountCheck() > 0 ? 'block' : 'hidden'}`}>
                    <span>{filteredCountCheck()}</span>
                </div>
            </div>
            <ModalCardComponent
                visibility={modalVisibility.filter}
                onClose={closeModalHandler}
                content={
                    <div className={"relative"}>
                        <form id={"form"} onSubmit={onSubmitHandler}>
                            <div
                                className={"col space-y-8 w-[800px] h-[400px] px-5 pt-5 py-5 bg-white overflow-y-scroll rounded-xl"}>
                                <p className={"text-center text-lg text-monstera font-semibold"}>Filter Analytics
                                    Order</p>
                                <div className={"row space-x-8"}>
                                    <div className={"col space-y-4 w-1/2"}>
                                        {fieldList[0].map((item, i) => (
                                            <InputComponent item={item} data={data[item.key]} api={API.ORDER_VOUCHER_LIST}
                                                            onChange={onChange} error={{}}/>
                                        ))}
                                    </div>
                                    <div className={"col space-y-4 w-1/2"}>
                                        <InputComponent item={fieldList[1]} data={data[fieldList[1].key]}
                                                        onChange={onChange} error={{}}/>
                                    </div>
                                </div>
                                <div
                                    className={"row font-semibold justify-center space-x-4"}>
                                    <button type={"button"} onClick={(e) => onSubmitHandler('clear', e)}
                                            className={"w-40 py-2 border border-fortress-grey hover:text-white hover:bg-dazzle rounded-lg"}>
                                        Clear Filter
                                    </button>
                                    <button type={"button"} onClick={(e) => onSubmitHandler('submit', e)}
                                            className={"w-40 py-2 bg-battleship-green hover:bg-monstera text-white rounded-lg"}>
                                        Filter Order
                                    </button>
                                </div>
                            </div>
                        </form>
                        <img src={CloseIcon} alt="closeButton"
                             className={"w-5 absolute right-4 top-2 cursor-pointer"}
                             onClick={closeModalHandler}/>
                    </div>
                }
            />
        </>
    )
}

export default AdvanceFilter
